module.exports = __webpack_public_path__ + "static/media/31-9.837e9806.mp3";